/**
 *
 * Common form classNames for BC Khimki(14326)
 *
 */

export const helperTextClassName = 'BC_Khimki-14326-advanced-form-field-helper-text';
